import React, { useState } from "react";
import clsx from "clsx";
// import defaultImage from 'images/sports/common/none_team_logo_v2.png';
import Url from "environment";
import suspendedImg from "images/sports/common/sports_suspended.png";
import cancelImg from "images/sports/common/sports_cancel.png";
import pendingImg from "images/sports/common/sports_pending.png";
import postponedImg from "images/sports/common/sports_postponed.png";
import cutImg from "images/sports/common/sports_cut.png";
import drawImg from "images/sports/baseball/baseball_tie.png";
import homeDefault from "images/sports/common/logo_home.png";
import awayDefault from "images/sports/common/logo_away.png";
import style from "./style.module.scss";

const SportsTeamLogo = ({ imgSize, imgUrl, isLazy = true, status }) => {
  const [isLoad, setIsLoad] = useState(false);
  const [isError, setIsError] = useState(false);
  const [fadeImage, setFadeImage] = useState(false);

  if (imgUrl && imgUrl.startsWith("/"))
    imgUrl = `${Url.thumb}/0x${imgSize}${imgUrl}`;
  else if (imgUrl && !imgUrl.startsWith("/"))
    imgUrl = `https://assets.b365api.com/images/team/b/${imgUrl}.png`;

  const statusImg = () => {
    let imgType = null;

    switch (status) {
      case "win":
        imgType = null;
        break;
      case "draw":
        imgType = drawImg;
        break;
      case "suspended":
        imgType = suspendedImg;
        break;
      case "cancel":
        imgType = cancelImg;
        break;
      case "pending":
        imgType = pendingImg;
        break;
      case "postponed":
        imgType = postponedImg;
        break;
      case "cut":
        imgType = cutImg;
        break;

      default:
        break;
    }

    if (!!imgType) {
      return (
        <img
          onLoad={(e) => onLoadedImage(e)}
          src={imgType}
          className={clsx(
            style.orgin_image
            // !fadeImage ? style.faded_out : style.fade_in
          )}
          height={`${imgSize}`}
        />
      );
    } else {
      return null;
    }
  };

  const onErrorImage = async (e) => {
    await setIsError(true);
  };

  const onLoadedImage = async (e) => {
    await setFadeImage(true);

    setTimeout(async () => {
      await setIsLoad(true);
    }, 300);
  };

  if (isLazy) {
    return (
      <div className={style.logo}>
        {/* {!isLoad && (
          <img
            src={defaultImage}
            style={{ width: `${imgSize}px`, height: `${imgSize}px` }}
            className={clsx(
              style.default_image,
              !fadeImage ? style.faded_out : style.fade_in,
              !isError && style.nonActive
            )}
          />
        )} */}
        {!isError && (
          <img
            onLoad={(e) => onLoadedImage(e)}
            onError={(e) => onErrorImage(e)}
            src={imgUrl}
            //   data-srcset={`${Url.thumb}/0x${imgSize}${imgUrl} ${imgSize}w,
            // ${Url.thumb}/0x${imgSize * 2}${imgUrl} ${imgSize * 2}w,
            // ${Url.thumb}/0x${imgSize * 3}${imgUrl} ${imgSize * 3}w,
            // `}
            //   srcSet={`${Url.thumb}/0x${imgSize}${imgUrl} ${imgSize}w,
            // ${Url.thumb}/0x${imgSize * 2}${imgUrl} ${imgSize * 2}w,
            // ${Url.thumb}/0x${imgSize * 3}${imgUrl} ${imgSize * 3}w,
            // `}
            className={clsx(
              // 'lazyload',
              style.orgin_image
              // !fadeImage ? style.faded_out : style.fade_in
            )}
            height={`${imgSize}`}
          />
        )}
      </div>
    );
  } else {
    if (!!imgUrl) {
      return (
        <div className={clsx(style.logo, !!status && style.statusLogo)}>
          {!isError && (
            <img
              onLoad={(e) => onLoadedImage(e)}
              //   srcSet={`${Url.thumb}/0x${imgSize}${imgUrl} ${imgSize}w,
              // ${Url.thumb}/0x${imgSize * 2}${imgUrl} ${imgSize * 2}w,
              // ${Url.thumb}/0x${imgSize * 3}${imgUrl} ${imgSize * 3}w,
              // `}
              src={imgUrl}
              className={clsx(
                style.orgin_image
                // !fadeImage ? style.faded_out : style.fade_in
              )}
              height={`${imgSize}`}
            />
          )}
        </div>
      );
    } else {
      return (
        <div className={clsx(style.logo, style.statusLogo)}>
          {statusImg()}
          {/* <img
            src={defaultImage}
            className={`default_image ${fadeImage ? 'faded_out' : 'fade_in'}`}
          /> */}
        </div>
      );
    }
  }
};

export default SportsTeamLogo;
